import { DatePickerInput, DatePickerInputProps, DatePickerType } from "@mantine/dates";
import { useTheme } from "@contexts/ThemeContext";

/**
 * JarvisDatePicker - A themed DatePickerInput component that automatically applies
 * the current theme colors to match the application's design system.
 *
 * Usage: Use this instead of Mantine's DatePickerInput to get automatic theming.
 */
export const JarvisDatePicker = <T extends DatePickerType = 'default'>(props: DatePickerInputProps<T>) => {
  const { colors: themeColors } = useTheme();

  return (
    <DatePickerInput
      {...props}
      styles={{
        input: {
          backgroundColor: themeColors.inputBackground,
          color: themeColors.inputText,
          borderColor: themeColors.inputBorder,
          '&:focus': {
            borderColor: themeColors.primary,
          },
          '&::placeholder': {
            color: themeColors.inputPlaceholder,
          },
          '&:disabled': {
            backgroundColor: themeColors.inputBackground,
            color: themeColors.inputText,
            opacity: 0.6,
          },
        },
        calendarHeaderControl: {
          color: themeColors.text,
        },
        calendarHeaderLevel: {
          color: themeColors.text,
        },
        weekday: {
          color: themeColors.textSecondary ?? themeColors.text,
        },
        day: {
          color: themeColors.text,
          '&[data-selected]': {
            backgroundColor: themeColors.primary,
            color: themeColors.buttonText ?? '#FFFFFF',
          },
          '&[data-today]': {
            borderColor: themeColors.primary,
          },
        },
      }}
      popoverProps={{
        styles: {
          dropdown: {
            backgroundColor: themeColors.card,
            borderColor: themeColors.border,
          },
        },
      }}
    />
  );
};

export default JarvisDatePicker;
